import sizes from '../sizes';

const scrollbar = {
    width: sizes.fixedSpacing.md,
    height: sizes.fixedSpacing.md,
    borderRadius: sizes.radius.full,
    marginTop: sizes.fixedSpacing.xxs,
    marginBottom: sizes.fixedSpacing.xxs
};

export default scrollbar;
